export default {
    init() {
        // JavaScript to be fired on all pages
        $('.nice_scroll').length && $('.nice_scroll').waypoint({
            handler: function () {
                $(this.element).addClass('is-scrolled');
            },
            offset: '80%',
        });
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $('#navbar-primary .navbar-nav li.dropdown .nav-link').click(function (e) {
            if ($(window).width() < 1200) {
                var grandparent = $(this).next();
                if ($(this).hasClass('open1') && grandparent.hasClass('opened')) {
                    document.location.href = this.href;
                } else {
                    $(this).addClass('open1');
                    $('#navbar-primary .navbar-nav').find('i').removeClass('opened');
                    $(this).next('.dropdown-toggle1').click();
                }
            } else {
                location.href = this.href;
            }
            e.preventDefault();
        });

        $('li.dropdown > .dropdown-toggle1').on('click', function (e) {
            var current = $(this).next();
            var current1 = $(this);
            var grandparent = $(this).parent().parent();
            grandparent.find('.dropdown-menu:visible').not(current).removeClass('show1');
            grandparent.find('.dropdown-toggle1').not(current1).removeClass('opened');
            $(this).toggleClass('opened');
            current.toggleClass('show1');
            e.stopPropagation();
        });
        $(function () {
            $('.navbar-toggler').click(function () {
                $(this).toggleClass('active');
            });
            $(window).on('scroll', function () {
                // Variable declaration for search container
                var src = $('#toggleBtn, #toggleBtn-desk');
                var currentScrollTop = $(this).scrollTop()

                if (currentScrollTop > 100) {
                    src.css({
                        'display': 'block',
                    });
                } else {
                    src.css({
                        'display': 'none',
                    });
                }
            });
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js